export type OpenBankingAccountType = "bridge" | "powens" | "gcl";
export type ProAccountAccountType = "swan" | "treezor";
export type AccountType = OpenBankingAccountType | ProAccountAccountType;

export const openBankingTypes: readonly OpenBankingAccountType[] = ["bridge", "powens", "gcl"];
export const proAccountTypes: readonly ProAccountAccountType[] = ["swan", "treezor"];

export function getProviderType(
  accountType: AccountType | "treezor",
): "proAccount" | "openBanking" {
  switch (accountType) {
    case "bridge":
    case "powens":
    case "gcl":
      return "openBanking";
    case "swan":
    case "treezor":
      return "proAccount";
  }
}
